import { action, observable } from 'mobx';
import { api } from '../config';

// Helpers
import { getPath } from '../helpers/helpers';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  filterParams:{
    fname: "",
    lname: ""
  },
  rosterTotal: null,
  courseRoster: [],
  rosterNext: null,
  examSession: {},
  // Get roster
  getCourseRoster: action(function(query, installSid, courseSid, backgroundLoad) {
    if(!backgroundLoad) {
      obx.courseRoster = [];
      SessionStore.startLoading('Loading…', 'getCourseRoster');
    } else {
      SessionStore.startBackgroundLoading('getCourseRoster');
    }

    if(typeof installSid === 'undefined' || !installSid) {
      installSid = SessionStore.userData.installSid;
    }

    if(typeof courseSid === 'undefined' || !courseSid) {
      courseSid = SessionStore.userData.courseSid;
    }

    if(!query) {
      query = '';
    }


    api.get(`/installs/${installSid}/courses/${courseSid}/enrollments${query}`)
      .then(response => {
        obx.courseRoster = response.data.results;


        // Set pagination next url
        if(response.data.next) {
          // API returns a url with a different domain for the next link
          // so create an anchor element and set its href to the next link
          // and then grab the pathname and query from that
          let nextUrl = getPath(response.data.next);
          nextUrl = nextUrl.replace('/v1', '');
          obx.rosterNext = nextUrl;
        } else {
          obx.rosterNext = null;
        }

        //we want the total to be the actual total of students enrolled so when we get the initial get request we want to keep that number the same
        if (response.data.total){
          obx.rosterTotal = response.data.total;
        } else {
          obx.rosterTotal = 0;
        }

        if(!backgroundLoad) {
          SessionStore.finishLoading('getCourseRoster');
        } else {
          SessionStore.finishBackgroundLoading('getCourseRoster');
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Assign a proctor
  // assignProctor: action(function (examSid, enrollmentSid, data, func) {
  //   SessionStore.startLoading('Loading…', 'AssignProctor');
  //   let { userData } = SessionStore;
  //
  //   api.put(`/installs/${userData.installSid}/courses/${userData.courseSid}/exams/${examSid}/enrollments/${enrollmentSid}/assignProctor`, data)
  //     .then(response => {
  //       SessionStore.finishLoading('AssignProctor');
  //       func();
  //     })
  //     .catch(error => {
  //       SessionStore.throwError(error);
  //     });
  // }),
  // Get session data
  getExamSession: action(function (examSid, sessionSid, component, callback) {
    SessionStore.startLoading('Loading…', 'GetExamSessionData');
    let { installSid } = SessionStore.userData;

    obx.examSession = {};

    api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}`)
      .then(response => {
        obx.examSession = response.data;
        SessionStore.finishLoading('GetExamSessionData');

        let proctorData = response.data.proctor;
        let location = response.data.location;

        if(proctorData) {
          proctorData.appointmentDateTime = response.data.appointmentDate;
          proctorData.company = response.data.location.accountName;
          obx.examSession.proctor.company = proctorData.company;
        }

        if(callback) {
          callback();
        }

        if(location && proctorData) {
          Object.keys(location).forEach(function(prop){
            if(prop !== 'latitude' && prop !== 'longitude') {
              proctorData[prop] = location[prop];
            } else if(prop === 'latitude') {
              proctorData.locationLatitude = location[prop];
            } else if(prop === 'longitude') {
              proctorData.locationLongitude = location[prop];
            }
          })
        }

        if(component) {
          component.setState({
            proctorData
          })
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get admin users
  adminUsers: [],
  getAdminUsers: action(function() {
    SessionStore.startLoading('Loading…', 'GetAdminUsers');

    obx.adminUsers = [];
    obx.admin = {};

    api.get(`/installs/${SessionStore.userData.installSid}/users?admin=true`)
      .then(response => {
        obx.adminUsers = response.data.results;
        SessionStore.finishLoading('GetAdminUsers');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get installation users
  installUsers: [],
  usersNext: null,
  getUsers: action(function(filters) {
    SessionStore.startLoading('Loading…', 'GetUsers');

    let query = '?limit=50&sortKeys=lastName';

    if(filters) {
      for(var key in filters) {
        if(filters[key]) {
          query += `&${key}=${filters[key]}`
        }
      }
    }

    api.get(`/installs/${SessionStore.userData.installSid}/users${query}`)
      .then(response => {
        obx.installUsers = response.data.results;

        // Set pagination next url
        if(response.data.next) {
          // API returns a url with a different domain for the next link
          // so create an anchor element and set its href to the next link
          // and then grab the pathname and query from that
          let nextUrl = getPath(response.data.next);
          nextUrl = nextUrl.replace('/v1', '');
          obx.usersNext = nextUrl;
        } else {
          obx.usersNext = null;
        }

        SessionStore.finishLoading('GetUsers');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get individual user
  user: null,
  getUser: action(function(userSid) {
    SessionStore.startLoading('Loading…', 'GetUser');

    obx.user = null;

    api.get(`/installs/${SessionStore.userData.installSid}/users/${userSid}/profile`)
      .then(response => {
        obx.user = response.data;
        SessionStore.finishLoading('GetUser');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get install enrollments
  installEnrollments: [],
  getInstallEnrollments: action(function(query) {
    SessionStore.startLoading('Loading…', 'GetInstallEnrollments');

    obx.installEnrollments = [];

    if(!query) {
      query = '';
    }

    api.get(`/installs/${SessionStore.userData.installSid}/enrollments${query}`)
      .then(response => {
        obx.installEnrollments = response.data.results;
        SessionStore.finishLoading('GetInstallEnrollments');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get user enrollments
  userEnrollments: [],
  getUserEnrollments: action(function(userSid, callback) {
    SessionStore.startLoading('Loading…', 'GetUserEnrollments');

    api.get(`/installs/${SessionStore.userData.installSid}/enrollments?userSid=${userSid}`)
      .then(response => {
        obx.userEnrollments[userSid] = response.data.results;

        if(callback) {
          callback();
        }

        // Get exam configurations for each enrollment
        response.data.results.forEach(enrollment => {
          obx.getEnrollmentConfigurations(userSid, enrollment.enrollmentSid);
        });

        SessionStore.finishLoading('GetUserEnrollments');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get exam configurations for enrollment
  getEnrollmentConfigurations: action(function(userSid, enrollmentSid) {
    SessionStore.startLoading('Loading…', 'GetEnrollmentConfigurations');

    api.get(`/installs/${SessionStore.userData.installSid}/examConfigurations?enrollmentSid=${enrollmentSid}`)
      .then(response => {
        let examConfiguration = {};

        // Only use configurations that don’t apply to an exam
        response.data.results.forEach(configuration => {
          if(!configuration.examSid) {
            examConfiguration = configuration
          }
        });

        // Set the configurations for the given enrollment
        obx.userEnrollments[userSid].filter(enrollment => {
          if(enrollment.enrollmentSid === enrollmentSid) {
            enrollment.examConfiguration = examConfiguration;
          }

          return true;
        });

        SessionStore.finishLoading('GetEnrollmentConfigurations');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update enrollment configuration data
  enrollmentConfiguration: {
    requiredSoftware: '',
    studentNotes: '',
    proctorNotes: '',
    proctorTypes: [],
    permittedBathroomBreak: false,
    permittedBathroomBreakInformation: '',
    permittedBlankPaper: false,
    permittedBlankPaperInformation: '',
    permittedCalculator: false,
    permittedCalculatorInformation: '',
    permittedDictionary: false,
    permittedDictionaryInformation: '',
    permittedEarplugs: false,
    permittedEarplugsInformation: '',
    permittedFormulaSheet: false,
    permittedFormulaSheetInformation: '',
    permittedNotes: false,
    permittedNotesInformation: '',
    permittedOtherItems: '',
    permittedTextbook: false,
    permittedTextbookInformation: '',
    permittedWebsites: false,
    permittedWebsitesInformation: '',
    instructorAsProctor: []
  },
  updateConfigurationData: action(function (data, func) {
    let newData = null;

    for (let key in data) {
      if (key) {
        newData = data[key];
        obx.enrollmentConfiguration[key] = newData;
      }
    }
  }),
  // Create exam configuration for enrollment
  createEnrollmentConfiguration: action(function(userSid, enrollmentSid, callback) {
    SessionStore.startLoading('Loading…', 'CreateEnrollmentConfiguration');

    let data = obx.enrollmentConfiguration;

    data.userSid = userSid;
    data.enrollmentSid = enrollmentSid;

    api.post(`/installs/${SessionStore.userData.installSid}/examConfigurations`, data)
      .then(response => {
        SessionStore.finishLoading('CreateEnrollmentConfiguration');

        // Get updated configurations for the enrollment
        obx.getEnrollmentConfigurations(userSid, enrollmentSid);

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update exam configuration for enrollment
  updateEnrollmentConfiguration: action(function(userSid, enrollmentSid, configurationSid, callback) {
    SessionStore.startLoading('Loading…', 'UpdateEnrollmentConfiguration');

    let data = obx.enrollmentConfiguration;

    data.userSid = userSid;
    data.enrollmentSid = enrollmentSid;
    data.instructorAsProctor = [];

    delete data.examOpenDate;
    delete data.examCloseDate;
    delete data.scheduleOpenDate;
    delete data.scheduleCloseDate;
    delete data.password;
    delete data.duration;
    delete data.examSid;
    delete data.sid;
    delete data.attemptsRemaining;
    delete data.locked;
    delete data.approved;
    delete data.approvedBy;
    delete data.createdDate;
    delete data.editDate;

    api.put(`/installs/${SessionStore.userData.installSid}/examConfigurations/${configurationSid}`, data)
      .then(response => {
        SessionStore.finishLoading('UpdateEnrollmentConfiguration');

        // Get updated configurations for the enrollment
        obx.getEnrollmentConfigurations(userSid, enrollmentSid);

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete exam configuration for enrollment
  deleteEnrollmentConfiguration: action(function(userSid, enrollmentSid, configurationSid) {
    SessionStore.startLoading('Loading…', 'DeleteEnrollmentConfiguration');

    api.delete(`/installs/${SessionStore.userData.installSid}/examConfigurations/${configurationSid}?enrollmentSid=${enrollmentSid}`)
      .then(response => {
        // Get updated configurations for the enrollment
        obx.getEnrollmentConfigurations(userSid, enrollmentSid);
        SessionStore.finishLoading('DeleteEnrollmentConfiguration');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get individual admin user
  admin: {},
  getAdminUser: action(function(userSid) {
    SessionStore.startLoading('Loading…', 'GetAdminUser');

    api.get(`/installs/${SessionStore.userData.installSid}/users/${userSid}/profile`)
      .then(response => {
        obx.admin = response.data;
        SessionStore.finishLoading('GetAdminUser');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete admin user
  deleteAdminUser: action(function(userSid, callback) {
    SessionStore.startLoading('Loading…', 'DeleteAdminUser');

    api.delete(`/installs/${SessionStore.userData.installSid}/users/${userSid}`)
      .then(response => {
        SessionStore.finishLoading('DeleteAdminUser');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update admin data
  updateAdminData: action(function(data) {
    let newData = null;

    for(let key in data) {
      if(key) {
        newData = data[key];
        obx.admin[key] = newData;
      }
    }
  }),
  // Update user API call
  updateAdmin: action(function(userSid, callback) {
    SessionStore.startLoading('Loading…', 'UpdateAdmin');

    let data = obx.admin;

    for(let prop in data) {
      if(
        prop !== 'firstName' &&
        prop !== 'lastName' &&
        prop !== 'email' &&
        prop !== 'homePhone' &&
        prop !== 'mobilePhone' &&
        prop !== 'currencyCode' &&
        prop !== 'timeZoneSid' &&
        prop !== 'username' &&
        prop !== 'password' &&
        prop !== 'enabled'
      ) {
        delete data[prop];
      }
    }

    api.put(`/installs/${SessionStore.userData.installSid}/users/${userSid}`, data)
      .then(response => {
        obx.admin = response.data;

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('UpdateAdmin');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Create admin user
  createAdmin: action(function(callback) {
    SessionStore.startLoading('Loading…', 'CreateAdmin');

    let data = obx.admin;

    data.enabled = true;

    api.post(`/installs/${SessionStore.userData.installSid}/users`, data)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('CreateAdmin');

        obx.getAdminUsers();
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/EnrollmentStore.js